import { Entity, Field } from "typegraph";
import Product from "panels/organizations/admin/entities/Product";

@Entity({one: "entry", many: "entries"})
export default class Entry {

	@Field()
	public id: string;
	
	@Field()
	public externalId: string;

    @Field()
    public startDate: string;
	
	@Field()
    public endDate: string;
	
	@Field()
	public sortIndex: string;
	
	@Field()
	public enrollCount: number;
	
	@Field()
	public enrollLimit: number;

	@Field()
	public displayName: string;
	
	@Field({entity: Product})
	public product: Product;

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/entities/Entry.ts